const SeriesSelectedOption = ({ currentSelectedPump }) => {
  return (
    <div className="series-selected-option flex-column column-start gap-5x">
      <div className="flex-column column-start">
        <h4>Наименование продукта: {currentSelectedPump?.name}</h4>
        <h4>Артикул: {currentSelectedPump?.article}</h4>
      </div>
      <div className="params flex-column column-start w-100 gap-5x">
        {currentSelectedPump?.param &&
          Object.values(currentSelectedPump.param)
            .sort((a, b) => a.sort - b.sort)
            .map((paramGroup) => (
              <div
                key={paramGroup.id}
                className="params__group flex-column column-start w-100 gap-3x"
              >
                <h4>{paramGroup.name}</h4>
                {paramGroup.params &&
                  Object.values(paramGroup.params).map((param) => (
                    <div
                      key={param.name + param.value}
                      className="params__item w-100"
                    >
                      <span className="text-s line-height-s">{param.name}</span>
                      <span className="params__dots" />
                      <span className="text-s line-height-s">
                        {param.value}
                      </span>
                    </div>
                  ))}
              </div>
            ))}
      </div>
    </div>
  );
};

export default SeriesSelectedOption;
